import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUtensils, faCheckSquare } from "@fortawesome/free-solid-svg-icons"

import SEO from "../components/seo"

export default ({ data, location }) => (
  <Layout>
    <SEO
      pagetitle="ChaNmA Blogについて"
      pagedesc="gatsbyを利用したサイトです"
      pagepath={location.pathname}
      pageimg={data.about.childImageSharp.original.src}
      pageimg={data.about.childImageSharp.original.width}
      pageimg={data.about.childImageSharp.original.height}
    />
    <div className="eyecatch">
      <figure>
        <Img fluid={data.about.childImageSharp.fluid} alt="ブルーベリー＆ヨーグルト" />
      </figure>
    </div>
    <article className="content">
      <div className="container">
        <h1 className="bar">ChaNmA Blogについて</h1>
        <div className="postbody">
          <p>GatsbyJSを利用して作成をしたブログです。</p>
          <h2><FontAwesomeIcon icon={faCheckSquare} />公開を予定している記事</h2>
          <p>これらの記事を今後公開していく予定です。</p>
          <ul>
            <li>学校生活で学んだことについて。</li>
            <li>日常生活について。</li>
          </ul>
        </div>
      </div>
    </article>
  </Layout>
)

export const query = graphql`
query {
  about: file(relativePath: { eq: "about.jpg"}) {
    childImageSharp {
      fluid(maxWidth: 1600) {
        ...GatsbyImageSharpFluid_withWebp
      }
      original {
        src
        height
        width
      }
    }
  }
}
`
